import { useTeam } from 'app/frontend/base/config/context/team'
import { Button } from '@/components/ui/button'
import SelectField from 'app/frontend/base/components/form-fields/SelectField'
import TextField from 'app/frontend/base/components/form-fields/TextField'
import { Pencil, UsersRound } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export type EditableAccessRestriction = wowaudit.AccessRestriction & {
  _destroy?: boolean
}

const name = 'access_restrictions_attributes'

const UserRestrictionIdentifierField = ({
  originalIndex,
  readonly,
  destroyed,
}: {
  originalIndex: number
  readonly: boolean
  destroyed?: boolean
}) => {
  const { team } = useTeam()
  const { watch, setValue } = useFormContext()
  const battletag = watch(`${name}.${originalIndex}.battletag`)
  const manualEntry = battletag !== null && battletag !== undefined
  const disabled = !!destroyed || readonly

  return (
    <div className='flex items-center gap-2'>
      {manualEntry ? (
        <TextField
          layout='stacked'
          className={`${destroyed ? 'opacity-30' : ''}`}
          name={`${name}.${originalIndex}.battletag`}
          disabled={disabled}
          customLabel={''}
          customPlaceholder={'Battletag#1234'}
        />
      ) : (
        <SelectField<wowaudit.UserReference>
          layout='stacked'
          className={`${destroyed ? 'opacity-30' : ''}`}
          name={`${name}.${originalIndex}.userId`}
          options={
            team.userReferences?.filter((ref) => ref.obfuscatedBattletag) ?? []
          }
          disabled={disabled}
          customLabel={''}
          customPlaceholder={'Select user'}
          optionLabelKey='obfuscatedBattletag'
          optionValueKey='id'
        />
      )}
      <span>or</span>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type='button'
            variant='outline'
            size='icon'
            className='h-10 w-10 shrink-0'
            disabled={disabled}
            onClick={() => {
              if (manualEntry) {
                setValue(`${name}.${originalIndex}.battletag`, null)
                return
              }

              setValue(`${name}.${originalIndex}.userId`, null)
              setValue(`${name}.${originalIndex}.battletag`, '')
            }}
          >
            {manualEntry ? <UsersRound size={14} /> : <Pencil size={14} />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {manualEntry ? 'Choose existing user' : 'Enter manually'}
        </TooltipContent>
      </Tooltip>
    </div>
  )
}

export default UserRestrictionIdentifierField
